"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.US = void 0;
exports.US = {
    numericCode: '840',
    alpha2Code: 'US',
    alpha3Code: 'USA',
    englishName: {
        short: 'United States of America (the)',
        full: 'the United States of America',
    },
    names: {
        full: {
            en: 'the United States of America',
            fr: "les États-Unis d'Amérique",
        },
        short: {
            en: 'United States of America (the)',
            fr: "États-Unis d'Amérique (les)",
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'US-DC': {
            numericCode: '840',
            code: 'US-DC',
            category: {
                id: '141',
                names: {
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district fédéral',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'District of Columbia',
            },
        },
        'US-AS': {
            numericCode: '840',
            code: 'US-AS',
            category: {
                id: '265',
                names: {
                    en: {
                        singular: 'outlying area',
                        plural: 'outlying areas',
                    },
                    fr: {
                        singular: 'zone éloignée',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'American Samoa (see also separate country code entry under AS)',
            },
        },
        'US-GU': {
            numericCode: '840',
            code: 'US-GU',
            category: {
                id: '265',
                names: {
                    en: {
                        singular: 'outlying area',
                        plural: 'outlying areas',
                    },
                    fr: {
                        singular: 'zone éloignée',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Guam (see also separate country code entry under GU)',
            },
        },
        'US-MP': {
            numericCode: '840',
            code: 'US-MP',
            category: {
                id: '265',
                names: {
                    en: {
                        singular: 'outlying area',
                        plural: 'outlying areas',
                    },
                    fr: {
                        singular: 'zone éloignée',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Northern Mariana Islands (see also separate country code entry under MP)',
            },
        },
        'US-PR': {
            numericCode: '840',
            code: 'US-PR',
            category: {
                id: '265',
                names: {
                    en: {
                        singular: 'outlying area',
                        plural: 'outlying areas',
                    },
                    fr: {
                        singular: 'zone éloignée',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Puerto Rico (see also separate country code entry under PR)',
            },
        },
        'US-UM': {
            numericCode: '840',
            code: 'US-UM',
            category: {
                id: '265',
                names: {
                    en: {
                        singular: 'outlying area',
                        plural: 'outlying areas',
                    },
                    fr: {
                        singular: 'zone éloignée',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'United States Minor Outlying Islands (see also separate country code entry under UM)',
            },
        },
        'US-VI': {
            numericCode: '840',
            code: 'US-VI',
            category: {
                id: '265',
                names: {
                    en: {
                        singular: 'outlying area',
                        plural: 'outlying areas',
                    },
                    fr: {
                        singular: 'zone éloignée',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Virgin Islands, U.S. (see also separate country code entry under VI)',
            },
        },
        'US-AK': {
            numericCode: '840',
            code: 'US-AK',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Alaska',
            },
        },
        'US-AL': {
            numericCode: '840',
            code: 'US-AL',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Alabama',
            },
        },
        'US-AR': {
            numericCode: '840',
            code: 'US-AR',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Arkansas',
            },
        },
        'US-AZ': {
            numericCode: '840',
            code: 'US-AZ',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Arizona',
            },
        },
        'US-CA': {
            numericCode: '840',
            code: 'US-CA',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'California',
            },
        },
        'US-CO': {
            numericCode: '840',
            code: 'US-CO',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Colorado',
            },
        },
        'US-CT': {
            numericCode: '840',
            code: 'US-CT',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Connecticut',
            },
        },
        'US-DE': {
            numericCode: '840',
            code: 'US-DE',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Delaware',
            },
        },
        'US-FL': {
            numericCode: '840',
            code: 'US-FL',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Florida',
            },
        },
        'US-GA': {
            numericCode: '840',
            code: 'US-GA',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Georgia',
            },
        },
        'US-HI': {
            numericCode: '840',
            code: 'US-HI',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Hawaii',
            },
        },
        'US-IA': {
            numericCode: '840',
            code: 'US-IA',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Iowa',
            },
        },
        'US-ID': {
            numericCode: '840',
            code: 'US-ID',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Idaho',
            },
        },
        'US-IL': {
            numericCode: '840',
            code: 'US-IL',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Illinois',
            },
        },
        'US-IN': {
            numericCode: '840',
            code: 'US-IN',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Indiana',
            },
        },
        'US-KS': {
            numericCode: '840',
            code: 'US-KS',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kansas',
            },
        },
        'US-KY': {
            numericCode: '840',
            code: 'US-KY',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Kentucky',
            },
        },
        'US-LA': {
            numericCode: '840',
            code: 'US-LA',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Louisiana',
            },
        },
        'US-MA': {
            numericCode: '840',
            code: 'US-MA',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Massachusetts',
            },
        },
        'US-MD': {
            numericCode: '840',
            code: 'US-MD',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Maryland',
            },
        },
        'US-ME': {
            numericCode: '840',
            code: 'US-ME',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Maine',
            },
        },
        'US-MI': {
            numericCode: '840',
            code: 'US-MI',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Michigan',
            },
        },
        'US-MN': {
            numericCode: '840',
            code: 'US-MN',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Minnesota',
            },
        },
        'US-MO': {
            numericCode: '840',
            code: 'US-MO',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Missouri',
            },
        },
        'US-MS': {
            numericCode: '840',
            code: 'US-MS',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Mississippi',
            },
        },
        'US-MT': {
            numericCode: '840',
            code: 'US-MT',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Montana',
            },
        },
        'US-NC': {
            numericCode: '840',
            code: 'US-NC',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'North Carolina',
            },
        },
        'US-ND': {
            numericCode: '840',
            code: 'US-ND',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'North Dakota',
            },
        },
        'US-NE': {
            numericCode: '840',
            code: 'US-NE',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Nebraska',
            },
        },
        'US-NH': {
            numericCode: '840',
            code: 'US-NH',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'New Hampshire',
            },
        },
        'US-NJ': {
            numericCode: '840',
            code: 'US-NJ',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'New Jersey',
            },
        },
        'US-NM': {
            numericCode: '840',
            code: 'US-NM',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'New Mexico',
            },
        },
        'US-NV': {
            numericCode: '840',
            code: 'US-NV',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Nevada',
            },
        },
        'US-NY': {
            numericCode: '840',
            code: 'US-NY',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'New York',
            },
        },
        'US-OH': {
            numericCode: '840',
            code: 'US-OH',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Ohio',
            },
        },
        'US-OK': {
            numericCode: '840',
            code: 'US-OK',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Oklahoma',
            },
        },
        'US-OR': {
            numericCode: '840',
            code: 'US-OR',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Oregon',
            },
        },
        'US-PA': {
            numericCode: '840',
            code: 'US-PA',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Pennsylvania',
            },
        },
        'US-RI': {
            numericCode: '840',
            code: 'US-RI',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Rhode Island',
            },
        },
        'US-SC': {
            numericCode: '840',
            code: 'US-SC',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'South Carolina',
            },
        },
        'US-SD': {
            numericCode: '840',
            code: 'US-SD',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'South Dakota',
            },
        },
        'US-TN': {
            numericCode: '840',
            code: 'US-TN',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Tennessee',
            },
        },
        'US-TX': {
            numericCode: '840',
            code: 'US-TX',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Texas',
            },
        },
        'US-UT': {
            numericCode: '840',
            code: 'US-UT',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Utah',
            },
        },
        'US-VA': {
            numericCode: '840',
            code: 'US-VA',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Virginia',
            },
        },
        'US-VT': {
            numericCode: '840',
            code: 'US-VT',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Vermont',
            },
        },
        'US-WA': {
            numericCode: '840',
            code: 'US-WA',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Washington',
            },
        },
        'US-WI': {
            numericCode: '840',
            code: 'US-WI',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Wisconsin',
            },
        },
        'US-WV': {
            numericCode: '840',
            code: 'US-WV',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'West Virginia',
            },
        },
        'US-WY': {
            numericCode: '840',
            code: 'US-WY',
            category: {
                id: '335',
                names: {
                    en: {
                        singular: 'state',
                        plural: 'states',
                    },
                    fr: {
                        singular: 'État',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Wyoming',
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVVMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY291bnRyaWVzL2RhdGEvVVMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7O0dBSUc7OztBQU1VLFFBQUEsRUFBRSxHQUFZO0lBQ3ZCLFdBQVcsRUFBRSxLQUFLO0lBQ2xCLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFdBQVcsRUFBRTtRQUNULEtBQUssRUFBRSxnQ0FBZ0M7UUFDdkMsSUFBSSxFQUFFLDhCQUE4QjtLQUN2QztJQUNELEtBQUssRUFBRTtRQUNILElBQUksRUFBRTtZQUNGLEVBQUUsRUFBRSw4QkFBOEI7WUFDbEMsRUFBRSxFQUFFLDJCQUEyQjtTQUNsQztRQUNELEtBQUssRUFBRTtZQUNILEVBQUUsRUFBRSxnQ0FBZ0M7WUFDcEMsRUFBRSxFQUFFLDZCQUE2QjtTQUNwQztLQUNKO0lBQ0QsU0FBUyxFQUFFO1FBQ1A7WUFDSSxrQkFBa0IsRUFBRSxJQUFJO1lBQ3hCLGtCQUFrQixFQUFFLEtBQUs7WUFDekIsZ0JBQWdCLEVBQUUsSUFBSTtTQUN6QjtRQUNEO1lBQ0ksa0JBQWtCLEVBQUUsSUFBSTtZQUN4QixrQkFBa0IsRUFBRSxLQUFLO1lBQ3pCLGdCQUFnQixFQUFFLEtBQUs7U0FDMUI7S0FDSjtJQUNELFlBQVksRUFBRTtRQUNWLE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLFVBQVU7d0JBQ3BCLE1BQU0sRUFBRSxXQUFXO3FCQUN0QjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGtCQUFrQjt3QkFDNUIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxzQkFBc0I7YUFDN0I7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGVBQWU7d0JBQ3pCLE1BQU0sRUFBRSxnQkFBZ0I7cUJBQzNCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZUFBZTt3QkFDekIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxnRUFBZ0U7YUFDdkU7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGVBQWU7d0JBQ3pCLE1BQU0sRUFBRSxnQkFBZ0I7cUJBQzNCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZUFBZTt3QkFDekIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxzREFBc0Q7YUFDN0Q7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGVBQWU7d0JBQ3pCLE1BQU0sRUFBRSxnQkFBZ0I7cUJBQzNCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZUFBZTt3QkFDekIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSwwRUFBMEU7YUFDakY7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGVBQWU7d0JBQ3pCLE1BQU0sRUFBRSxnQkFBZ0I7cUJBQzNCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZUFBZTt3QkFDekIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSw2REFBNkQ7YUFDcEU7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGVBQWU7d0JBQ3pCLE1BQU0sRUFBRSxnQkFBZ0I7cUJBQzNCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZUFBZTt3QkFDekIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxzRkFBc0Y7YUFDN0Y7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGVBQWU7d0JBQ3pCLE1BQU0sRUFBRSxnQkFBZ0I7cUJBQzNCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZUFBZTt3QkFDekIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxzRUFBc0U7YUFDN0U7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxTQUFTO2FBQ2hCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFlBQVk7YUFDbkI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxhQUFhO2FBQ3BCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFVBQVU7YUFDakI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsU0FBUzthQUNoQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxTQUFTO2FBQ2hCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFFBQVE7YUFDZjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxNQUFNO2FBQ2I7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsT0FBTzthQUNkO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFVBQVU7YUFDakI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsU0FBUzthQUNoQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxRQUFRO2FBQ2Y7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxXQUFXO2FBQ2xCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGVBQWU7YUFDdEI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxPQUFPO2FBQ2Q7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxXQUFXO2FBQ2xCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFVBQVU7YUFDakI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsYUFBYTthQUNwQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxTQUFTO2FBQ2hCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGdCQUFnQjthQUN2QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxjQUFjO2FBQ3JCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFVBQVU7YUFDakI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsZUFBZTthQUN0QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxZQUFZO2FBQ25CO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFlBQVk7YUFDbkI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFVBQVU7YUFDakI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsTUFBTTthQUNiO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFVBQVU7YUFDakI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsUUFBUTthQUNmO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGNBQWM7YUFDckI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsY0FBYzthQUNyQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxnQkFBZ0I7YUFDdkI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsY0FBYzthQUNyQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxXQUFXO2FBQ2xCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLE9BQU87YUFDZDtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxNQUFNO2FBQ2I7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsVUFBVTthQUNqQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxTQUFTO2FBQ2hCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFlBQVk7YUFDbkI7U0FDSjtRQUNELE9BQU8sRUFBRTtZQUNMLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxPQUFPO1lBQ2IsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE9BQU87d0JBQ2pCLE1BQU0sRUFBRSxRQUFRO3FCQUNuQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsV0FBVzthQUNsQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsT0FBTzt3QkFDakIsTUFBTSxFQUFFLFFBQVE7cUJBQ25CO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsTUFBTTt3QkFDaEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxlQUFlO2FBQ3RCO1NBQ0o7UUFDRCxPQUFPLEVBQUU7WUFDTCxXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsT0FBTztZQUNiLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxPQUFPO3dCQUNqQixNQUFNLEVBQUUsUUFBUTtxQkFDbkI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLFNBQVM7YUFDaEI7U0FDSjtLQUNKO0NBQ0osQ0FBQSJ9